import apiClient from './client';
import type { GamNetwork } from '@/lib/gamNetwork';

// Contas GAM do seletor (tabela gam_networks), a padrão primeiro.
export const getNetworks = async (): Promise<GamNetwork[]> => {
    const response = await apiClient.get<GamNetwork[]>('/networks');
    return response.data;
};
